import { render, staticRenderFns } from "./ProviderShowHeader.vue?vue&type=template&id=334f9a0c"
import script from "./ProviderShowHeader.vue?vue&type=script&lang=js"
export * from "./ProviderShowHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports